import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESTextArea } from "@app/shared/qes-standards/forms/TextArea";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import TutorialsService from "@app/tutorials/tutorialsService";
import { FC, useContext, useRef, useState } from "react";
import { toast } from "react-toastify";

interface EditTutorialsProps {
    containerReference: string;
    containerItem: string;
    itemExtension: string;
    rowTitle: string;
    updateContainerUI: (newDataString: string) => void;
    hyperlinkURL: string;
}

export const EditTutorialsHyperlinkFlyout: FC<EditTutorialsProps> =
  ({ containerReference, containerItem, itemExtension, rowTitle, updateContainerUI, hyperlinkURL }: EditTutorialsProps) => {
    const [newRowTitle, setNewRowTitle] = useState(rowTitle);
    const [newURL, setNewURL] = useState(hyperlinkURL);
    const flyoutContext = useContext(FlyoutContext);
    const supportService = useRef(new TutorialsService()).current;

    const handleSubmit = async () => {
      await supportService.deleteBlobSas(containerReference, containerItem, itemExtension)
      const tempRowTitle = (newRowTitle != "") ? newRowTitle : rowTitle;
      const tempHyperlinkURL = (newURL != "") ? newURL : hyperlinkURL;
      const newDataStr = await supportService.updateHyperlinkBlobSas(containerReference, tempRowTitle, tempHyperlinkURL);
      updateContainerUI(newDataStr);
      toast(<span>Tutorial &quot;{newRowTitle}&quot; successfully updated</span>, {
        containerId: "z-index-9999",
        type: "success",
      });
      flyoutContext.handleCloseFlyout();
    };

    return (
      <>
        <div className="form-group row">
          <div className="col-6">
            <QESTextInput
              label="New Display Title:"
              testId="tutorials__file-name-input"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setNewRowTitle(e.target.value) }}
              value={newRowTitle}
            />
          </div>
        </div>
        <p className="mt-4">Enter the URL for the new tutorial hyperlink.</p>
        <QESTextArea
          label="Hyperlink:"
          testId="tutorials__file-name-input"
          onChange={(e) => setNewURL(e.target.value)}
          value={newURL}
        />
        <FlyoutFooter
          submitButton={<QESButton qesType="primary" qesTestId="termination-flyout__submit" onClick={handleSubmit} disabled={ !hyperlinkURL }>Submit</QESButton>}
        />
      </>
    );
  }